import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Use titles`}</h3>
    <p>{`So your stepper is useful even for `}<a parentName="p" {...{
        "href": "/foundation/accessibility/"
      }}>{`people who don’t see visual cues`}</a>{`,
include titles for each increment button.
This means using text like “Add a passenger” and “Remove a passenger”
to make it clear directly in the button what the result of the button is.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      